export default function ({ app, $config }) {
  if (!$config.gtmId) return;
  app.$gtm.init($config.gtmId);
};

export const gtmConfig = {
    enabled: true,
    autoInit: false,
    layer: 'dataLayer',
    pageTracking: true,
    respectDoNotTrack: false,
    pageViewEventName: 'nuxtRoute',
};
